//import Dashboard from "views/Dashboard.js";

//Macro

//import Gestao from "views/Gestao.js";
//import Perfil from "views/Perfil.js";

var routes = [

];
export default routes;
